<template>
    <div>
        <section class="section hero-section bg-ico-home-1 p-3" style="height: 220px;">
            <div class="container mb-0 mt-5">
                <div class="row">
                    <div class="col-lg-12 mt-5">
                        <div class="text-left">
                            <h1 class="text-white" data-aos="fade-left">Syarat dan Ketentuan</h1>
                            <p class="text-white" data-aos="fade-right"><em>Diperbarui terakhir pada: 24 Maret 2024</em>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section bg-white pt-3">
            <div class="container mt-2">
                <h2 class="text-left font-weight-bold mb-3" data-aos="fade-up">
                    1. PENGGUNAAN APLIKASI AWAN
                </h2>
                <p class="font-size-16 text-left" data-aos="fade-left">
                <section>
                    <h4 class="text-left font-weight-bold mb-3">Registrasi:</h4>
                    <ul>
                        <li>Untuk dapat menjadi pengguna Aplikasi AWAN ("Pengguna AWAN"), Anda harus melakukan
                            registrasi melalui Aplikasi AWAN.</li>
                        <li>Anda wajib memastikan kebenaran dan keakuratan setiap data, informasi, dan/atau keterangan
                            dalam bentuk apapun yang dari waktu ke waktu Anda sampaikan kepada Kami.</li>
                    </ul>

                    <h4 class="text-left font-weight-bold mb-3">Verifikasi Nomor Telepon (kode OTP):</h4>
                    <ul>
                        <li>Kode OTP akan dikirimkan ketika Pengguna AWAN membuat akun baru.</li>
                        <li>Pengguna AWAN harus menunggu 1 menit setelah 1 kali permintaan kode OTP dapat dikirim
                            kembali.</li>
                        <li>Pengguna AWAN wajib menjaga kerahasiaan kode OTP dan tidak membagikannya kepada siapa pun.
                        </li>
                    </ul>

                    <h4 class="text-left font-weight-bold mb-3">Verifikasi Email:</h4>
                    <ul>
                        <li>Email akan dikirimkan ketika Pengguna AWAN memperbarui profil AWAN baru.</li>
                        <li>Pengguna AWAN wajib memverifikasi email setelah email diterima.</li>
                    </ul>

                    <h4 class="text-left font-weight-bold mb-3">Security Code (Kode PIN):</h4>
                    <ul>
                        <li>Saat proses registrasi akun baru, Pengguna AWAN diwajibkan membuat Security Code (Kode PIN).
                        </li>
                        <li>Security Code (Kode PIN) dibuat oleh Pengguna AWAN saat melakukan registrasi akun baru, yang
                            terdiri dari 6 (enam) digit angka.</li>
                        <li>Akun AWAN akan diblokir selama beberapa saat jika Pengguna AWAN memasukkan Security Code
                            (Kode PIN) yang salah sebanyak 5 kali berturut-turut.</li>
                        <li>Pengguna AWAN wajib menjaga kerahasiaan Security Code (Kode PIN) dan tidak membagikannya
                            kepada siapa pun.</li>
                    </ul>
                </section>
                </p>
                <h2 class="text-left font-weight-bold mb-3" data-aos="fade-up">
                    2. PERLINDUNGAN DAN KERAHASIAAN DATA
                </h2>
                <p class="font-size-16 text-left" data-aos="fade-left">
                <section>
                    <p>Anda setuju bahwa pengumpulan, pemanfaatan, dan penyerahan Data yang Anda sampaikan kepada Kami
                        akan dilakukan dengan tunduk kepada Syarat dan Ketentuan ini dan kebijakan privasi yang terdapat
                        di: <a href="https://awanbisnis/kebijakan-privasi">https://awanbisnis/kebijakan-privasi</a> yang
                        menjadi satu kesatuan yang tak terpisahkan dengan Syarat dan Ketentuan ini.</p>
                </section>
                </p>
                <h2 class="text-left font-weight-bold mb-3" data-aos="fade-up">
                    3. HUBUNGI KAMI
                </h2>
                <p class="font-size-16 text-left" data-aos="fade-left">
                <section>
                    <p>Untuk setiap masalah yang berkaitan dengan Aplikasi AWAN dan/atau akun Anda, atau pertanyaan
                        mengenai Syarat dan Ketentuan ini Anda dapat meminta bantuan pada Contact Center atau Layanan
                        Pengguna Awan (dengan menyertakan bukti pendukung), melalui:</p>
                </section>
                <ul>
                    <li>Telepon ke nomor <a href="tel:+6287887140474">+628-152-943-0000</a></li>
                    <li>Email ke <a href="mailto:info@awanbisnis.com">info@awanbisnis.com</a></li>
                    <li>Pusat Bantuan di Aplikasi AWAN:
                        <ul>
                            <li>Facebook: <a
                                    href="https://www.facebook.com/awanbisnis">https://www.facebook.com/awanbisnis</a>
                            </li>
                            <li>Instagram: <a
                                    href="https://www.instagram.com/awanbisnis">https://www.instagram.com/awanbisnis</a>
                            </li>
                        </ul>
                    </li>
                </ul>
                </p>
                <h2 class="text-left font-weight-bold mb-3" data-aos="fade-up">
                    4. TANGGAL BERLAKU
                </h2>
                <p class="font-size-16 text-left" data-aos="fade-left">
                <section>
                    <p>Syarat dan Ketentuan ini berlaku sejak tanggal 1 Januari 2020.</p>
                </section>
                </p>
            </div>
        </section>

    </div>
</template>
<script>
export default {
    name: 'SyaratKetentuan',
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
        // title
        document.title = 'Syarat dan Ketentuan'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>